module.exports = __webpack_public_path__ + "img/dash.d38f2466.svg";